import { Button } from "@tracify/ui/button";
import { Card } from "@tracify/ui/card";
import { LockClosedIcon } from "@heroicons/react/24/solid";
import { useLogout } from "@lib/api-hooks/useLogout/useLogout";
import React from "react";

type ScopedRouteInterface = {
  accessFlag: boolean;
  title: string;
  message: string;
};

export function ScopedRoute(props: ScopedRouteInterface) {
  const { accessFlag, title, message } = props;
  const logout = useLogout();

  const handleLogout = async () => {
    try {
      await logout.mutateAsync();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return accessFlag ? (
    <div className="w-full h-screen flex flex-col justify-center items-center overflow-y-auto">
      <Card className="max-w-[95vw] w-96 md:max-w-xl md:w-full xl:max-w-2xl flex flex-col px-3 py-6 md:px-6 md:py-8 gap-3 md:gap-4">
        <div className="flex items-center m-auto justify-center bg-primary rounded-full w-16 h-16">
          <LockClosedIcon className="text-white dark:text-foreground w-8 h-8" />
        </div>
        <p className="text-foreground h2 font-bold text-center">{title}</p>
        <p className="text-muted-foreground text-sm md:text-base text-center">
          {message}
        </p>
        <Button variant="secondary" onClick={handleLogout} className="w-full">
          Logout
        </Button>
      </Card>
    </div>
  ) : null;
}
